export const workspaceGerman = {
  created: 'Workspace „{{name}}“ angelegt',
  createdInvited: 'Workspace „{{name}}“ angelegt – die Einladung ist unterwegs',
  emptyDescription:
    'Lege den ersten Kunden-Workspace an. Du kannst ihn selbst vorbereiten oder direkt einen Administrator einladen.',
  createDescription:
    'Legt den Workspace mit Rechnungsvorlage an. Du kannst ihn selbst vorbereiten und das Team später einladen.',
  inviteAdmin: 'Ersten Administrator einladen',
  inviteAdminHint:
    'Optional. Ohne Einladung kannst du als Plattform-Admin in den Workspace wechseln und ihn einrichten.',
  createOnly: 'Workspace anlegen',
  createAndInvite: 'Anlegen und einladen',
  contactHint:
    'Bei einer Einladung mit der Admin-Adresse vorbelegt; leer heißt: keine. Die Kontaktadresse kann später geändert werden.',
};

export const workspaceEnglish = {
  created: 'Workspace “{{name}}” created',
  createdInvited: 'Workspace “{{name}}” created – the invitation is on its way',
  emptyDescription:
    'Create the first customer workspace. You can prepare it yourself or invite an administrator right away.',
  createDescription:
    'Creates the workspace with an invoice template. You can prepare it yourself and invite the team later.',
  inviteAdmin: 'Invite the first administrator',
  inviteAdminHint:
    'Optional. Without an invitation, you can enter and set up the workspace as a platform administrator.',
  createOnly: 'Create workspace',
  createAndInvite: 'Create and invite',
  contactHint:
    'Prefilled with the administrator’s address when inviting; leave blank for none. The contact address can be changed later.',
};
